import React from 'react';
import { MapPinIcon, PhoneIcon, MusicIcon, MessageCircleIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { Reveal } from './Reveal';
import { COMPANY, waLink } from '../data/company';
export function Contact() {
  const items = [{
    icon: MapPinIcon,
    label: 'Alamat',
    value: COMPANY.address,
    href: `https://maps.google.com/?q=${encodeURIComponent(COMPANY.address)}`
  }, {
    icon: PhoneIcon,
    label: 'WhatsApp / HP',
    value: COMPANY.phoneDisplay,
    href: waLink(`Halo ${COMPANY.name}, saya ingin bertanya.`)
  }, {
    icon: MusicIcon,
    label: 'TikTok',
    value: COMPANY.tiktok,
    href: COMPANY.tiktokUrl
  }];
  return <section id="kontak" className="relative bg-ink py-24" data-id="element-50" data-mp="3f62uviz4w6x2">
      <div className="mx-auto max-w-7xl px-5" data-id="element-51" data-mp="ggkstkm44n15">
        <SectionHeading eyebrow="Kontak" title={<>Hubungi <span className="text-gold-gradient" data-id="element-53" data-mp="bougj93m7p73">Kami</span></>} subtitle="Siap melayani Anda 24 jam. Jangan ragu untuk menghubungi kami kapan saja." data-id="element-52" data-mp="gifi1b4f31b1" />

        <div className="mt-14 grid gap-6 md:grid-cols-3" data-id="element-54" data-mp="3ov7e2uk60ev9">
          {items.map((it, i) => {
          const Icon = it.icon;
          return <Reveal key={it.label} delay={i * 0.1} data-id="element-55" data-mp="3b30ypaou6bwv" data-mpi={i}>
                <a href={it.href} target="_blank" rel="noopener noreferrer" className="flex h-full flex-col items-center gap-4 rounded-3xl border border-white/5 bg-ink-card p-8 text-center transition-all hover:-translate-y-1 hover:border-gold/40" data-id="element-56" data-mp="3f42yptqkurzw">
                  <div className="grid h-14 w-14 place-items-center rounded-full gold-border text-gold" data-id="element-57" data-mp="2s5ztppva8bsx">
                    <Icon className="h-6 w-6" data-id="element-58" data-mp="2w6a6pmhhs2ha" />
                  </div>
                  <div data-id="element-59" data-mp="qe3d41u9cbra">
                    <div className="text-xs uppercase tracking-wider text-gold/80" data-id="element-60" data-mp="qdtn4e97q4ll">{it.label}</div>
                    <div className="mt-1 text-sm font-medium text-white/85" data-id="element-61" data-mp="uducuv1ri27y">{it.value}</div>
                  </div>
                </a>
              </Reveal>;
        })}
        </div>

        <Reveal delay={0.2} data-id="element-62" data-mp="1yaxwbo869c2j">
          <div className="mt-10 text-center" data-id="element-63" data-mp="1uaw1nz0utiwr">
            <a href={waLink(`Halo ${COMPANY.name}, saya ingin memesan rental mobil.`)} target="_blank" rel="noopener noreferrer" className="btn-glow-gold inline-flex items-center justify-center gap-2 rounded-full px-8 py-4 text-base font-semibold" data-id="element-64" data-mp="1ubxgmekzqpjr">
              <MessageCircleIcon className="h-5 w-5" data-id="element-65" data-mp="2i101rweu30j0" /> Chat WhatsApp Sekarang
            </a>
          </div>
        </Reveal>
      </div>
    </section>;
}